<app-navbar></app-navbar>
<div class="d-flex justify-content-center align-items-center" style="height: 90vh">
	<ng-template #showBtn>
		<button (click)="generateOffers()" class="refreshBtn" mat-raised-button color="primary">
			Generuj oferty
		</button></ng-template
	>
	<div class="w-75" *ngIf="processing; else showBtn">
		<mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
		<p class="text-center py-1">{{ progress }}%</p>
	</div>
</div>
